import request from '@/utils/http'

export class BaseClass {
  customer = '/api/Customer'
  user = '/api/User'
  account = '/api/Account'
  menu = '/api/Menu'
  role = '/api/Role'
  goods = '/api/Goods'
  goodsCate = '/api/GoodsCategory'
  order = '/api/Order'
  reserveOrder = '/api/ReserveOrder'
  finAccount = '/api/FinAccount'
  stat = '/api/Stat'
  config = '/api/Config'
  ad = '/api/Ad'
  news = '/api/News'
  newsType = '/api/NewsType'
  bill = '/api/Bill'
  partner = '/api/Partner'

  post (url, data, responseType = 'json', options = {}) {
    return request({
      url, method: 'POST', data, headers: { responseType }, ...options
    })
  }

  put (url, data) {
    return request({
      url, method: 'PUT', data
    })
  }

  patch (url, data) {
    return request({
      url, method: 'PATCH', data
    })
  }

  delete (url, params) {
    return request({
      url, method: 'DELETE', params
    })
  }

  get (url, params) {
    return request({
      url, method: 'GET', params
    })
  }

  upload (url, data) {
    return request({
      url, method: 'post', data, headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  }

  export (url, method, params) {
    const options = {
      url, method, responseType: 'blob', timeout: 0
    }
    if (method === 'POST') {
      options.data = params
    } else {
      options.params = params
    }
    return request(options)
  }
}
